import { render, staticRenderFns } from "./ClinicCardSkeleton.vue?vue&type=template&id=11389f7e&"
import script from "./ClinicCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./ClinicCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ClinicCardSkeleton.vue?vue&type=style&index=0&id=11389f7e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11389f7e')) {
      api.createRecord('11389f7e', component.options)
    } else {
      api.reload('11389f7e', component.options)
    }
    module.hot.accept("./ClinicCardSkeleton.vue?vue&type=template&id=11389f7e&", function () {
      api.rerender('11389f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/mobile/skeletons/ClinicCardSkeleton.vue"
export default component.exports